import { InsightSearchResultsProps } from "../Models/Generated/InsightSearchResultsProps";
import { InsightSearchBlockProps } from "../Models/Generated/InsightSearchBlockProps";

export class InsightSearchClient {
  constructor(
    private endpoint?: string,
    private blockEndpoint?: string,
    private language?: string,
    private pageId?: number
  ) {}

  public GetItems = (
    term: string,
    pageNumber: number,
    orderByRelevance: boolean,
    filter1?: string,
    filter2?: string,
    filter3?: string,
    filter4?: string,
    filter5?: string,
    reportPublishedYear?: string,
    publishedYear?: string,
    fuzzy?: boolean,
    isArticle?: boolean
  ): Promise<InsightSearchResultsProps> =>
    fetch(
      `${this.endpoint}` +
        `?pageId=${this.pageId}` +
        `&language=${this.language}` +
        `&pageNumber=${pageNumber}` +
        `&orderBy=${orderByRelevance ? "relevance" : "date"}` +
        `&term=${term}` +
        `&filter1=${filter1}` +
        `&filter2=${filter2 ?? ""}` +
        `&filter3=${filter3 ?? ""}` +
        `&filter4=${filter4 ?? ""}` +
        `&filter5=${filter5 ?? ""}` +
        `&reportpublishedyear=${reportPublishedYear ?? ""}` +
        `&publishedYear=${publishedYear ?? ""}` +
        `&fuzzy=${fuzzy ? "true" : "false"}` +
        `&isArticle=${isArticle ? "true" : "false"}`
    ).then((response) => {
      if (!response.ok) throw new Error("Error from search API");
      return response.json();
    });

  public GetSearchBlock = (
    term: string,
    orderByRelevance: boolean,
    fuzzy?: boolean,
    isArticle?: boolean
  ): Promise<InsightSearchBlockProps> =>
    fetch(
        `${this.blockEndpoint}` +
        `?pageId=${this.pageId}` +
        `&language=${this.language}` +
        `&pageNumber=1` +
        `&orderBy=${orderByRelevance ? "relevance" : "date"}` +
        `&term=${term}` +
        `&fuzzy=${fuzzy ? "true" : "false"}` +
        `&isArticle=${isArticle ? "true" : "false"}`
    ).then((response) => {
      if (!response.ok) throw new Error("Error from block search API");
      return response.json();
    });

  public UpdateSearchUrl = (
    term: string,
    pageNumber: number,
    orderByRelevance: boolean,
    customFilter?: string,
    publicationType?: string,
    publicationArea?: string,
    publicationTheme?: string,
    reportPublishedYear?: string,
    fuzzy?: boolean,
    isArticle?: boolean
  ) => {
    const currentUrl = window.location.href.split("?")[0];
    const params = [
      !!term && term !== "" ? "term=" + term : null,
      "page=" + pageNumber,
      orderByRelevance ? "sortby=relevance" : "sortby=date",
      (customFilter ?? "") !== "" ? `customfilter=${customFilter}` : null,
      (publicationType ?? "") !== ""
        ? `publicationtype=${publicationType}`
        : null,
      (publicationArea ?? "") !== ""
        ? "publicationarea=" + publicationArea
        : null,
      (publicationTheme ?? "") !== ""
        ? "publicationtheme=" + publicationTheme
        : null,
      !!reportPublishedYear && reportPublishedYear !== ""
        ? "reportpublishedyear=" + reportPublishedYear
        : null,
      fuzzy ? "fuzzy=true" : null,
      isArticle ? "isArticle=true" : null,
    ].filter((p) => p !== null);
    const newUrl = currentUrl + "?" + params.join("&");
    window.history.pushState({}, "", newUrl);
  };
}
